"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": "div.modal_6c5710bd{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;padding:250px 0 10px;position:static}\n" }]);
exports.modal = "modal_6c5710bd";
//# sourceMappingURL=LinkDialog.scss.g.js.map